import { toast } from "sonner";
import { ArrowRight, Copy, Mail } from "lucide-react";
import { CONTACT_EMAIL, SETUP_MAILTO } from "./homeData";

const TONES = {
  orange: "bg-[#EA580C] text-white hover:bg-[#C2410C]",
  navy: "bg-[#1E3A5F] text-white hover:bg-[#172E4B]",
};

// Primary "get set up" call to action: opens an email to the team with a short template.
export const EmailSetupButton = ({ testid, label = "Email us to get set up", tone = "orange", className = "" }) => (
  <a href={SETUP_MAILTO} data-testid={testid}
    className={`group inline-flex items-center gap-2 rounded-full px-7 py-3.5 font-bold transition-colors ${TONES[tone]} ${className}`}>
    <Mail className="w-4 h-4" /> {label} <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
  </a>
);

const copy = async () => {
  try { await navigator.clipboard.writeText(CONTACT_EMAIL); toast.success("Email address copied"); }
  catch { toast.message(CONTACT_EMAIL); }
};

// Shows the address too, for computers with no email app set up.
export const MailLine = ({ testid, dark = true, prefix = "Or write to" }) => (
  <p className={`text-sm flex flex-wrap items-center gap-x-1.5 gap-y-1 ${dark ? "text-slate-400" : "text-slate-600"}`} data-testid={testid}>
    {prefix}
    <a href={SETUP_MAILTO} className={`font-semibold underline-offset-4 hover:underline ${dark ? "text-white" : "text-[#1E3A5F]"}`}>{CONTACT_EMAIL}</a>
    <button type="button" onClick={copy} aria-label="Copy email address" data-testid={`${testid}-copy`}
      className={`w-7 h-7 rounded-full grid place-items-center transition-colors ${dark ? "hover:bg-white/10" : "hover:bg-slate-100"}`}>
      <Copy className="w-3.5 h-3.5" />
    </button>
  </p>
);
